import { render, staticRenderFns } from "./SiteSwitcher.vue?vue&type=template&id=b5f8fe02&scoped=true"
import script from "./SiteSwitcher.vue?vue&type=script&lang=js"
export * from "./SiteSwitcher.vue?vue&type=script&lang=js"
import style0 from "./SiteSwitcher.vue?vue&type=style&index=0&id=b5f8fe02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f8fe02",
  null
  
)

export default component.exports